import { LoadError, LoadingOverlay, getModuleUrl, useTenant } from "@dehub/theme";
import qs from "qs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { AuthApi, GeneralApi } from "@/apis";
import { authChange, authMe } from "@/store/Auth";
import { initGeneral } from "@/store/General";

type Failure = "noToken" | "failed";

export function AccessPage() {
  const { t } = useTranslation("common");
  const tenant = useTenant();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [failure, setFailure] = useState<Failure | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const params = qs.parse(location.search);
        const token = params["?token"] as string | undefined;
        if (!token) {
          setFailure("noToken");
          return;
        }
        dispatch(authChange({ accessToken: token, sessionScope: "AUTHORIZED" } as any));
        const [res, auth] = await Promise.all([GeneralApi.init(), AuthApi.me()]);
        dispatch(initGeneral(res));
        dispatch(authMe(auth));
        navigate("/organization");
      } catch {
        // The token did not work: drop it so the app does not keep half a session.
        dispatch(authChange());
        setFailure("failed");
      }
    })();
  }, [dispatch, location, navigate]);

  if (failure) {
    return (
      <LoadError
        title={t(`access.${failure}Title`)}
        message={t(`access.${failure}Text`)}
        retryLabel={t("access.signIn")}
        onRetry={() => {
          window.location.href = `${getModuleUrl("", tenant?.modulesDomain)}/login`;
        }}
      />
    );
  }

  return <LoadingOverlay visible />;
}
